<template>
  <!-- eslint-disable max-len -->
  <div class="header flex flex-auto items-start text-white">
    <div class="header-controls mt-6 sm:mt-20 mx-auto pb-4 container flex flex-col sm:flex-row justify-between border-b border-indigo-600">
      <div class="logo ml-4 sm:hidden">
        <router-link :to="{name: 'event.overview'}">
          <mj-icon
            src="moment-juke-logo"
            class="w-32 sm:w-40 h-auto"
          />
        </router-link>
      </div>
      <div class="flex flex-row justify-between w-full">
        <div class="control-wrapper flex flex-col sm:flex-row sm:items-center">
          <div class="logo sm:mt-8 sm:mr-3 hidden sm:block">
            <router-link :to="{name: 'event.overview'}">
              <mj-icon
                src="moment-juke-logo"
                class="w-32 sm:w-40 h-auto"
              />
            </router-link>
          </div>
          <div
            v-if="isInitalized && hasFinishedWizard && isSpotifyAuthorized"
            class="eventname text-xl"
          >
            <mj-event-navigatin-drop-down-menu />
          </div>
        </div>
        <div
          v-if="isInitalized & isDefaultUser && hasFinishedWizard && isSpotifyAuthorized"
          class="control-wrapper flex items-center pr-4"
        >
          <div class="notification mr-6">
            <mj-notifications-drop-down-menu />
          </div>
          <div class="avatar">
            <mj-profile-drop-down-menu />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EventNavigationDropDownMenu from '@/components/event/EventNavigationDropDownMenu.vue';
import ProfileDropDownMenu from '@/components/profile/ProfileDropDownMenu.vue';
import NotificationsDropDownMenu from '@/components/notifications/NotificationsDropDownMenu.vue';

export default {
  name: 'Header',

  components: {
    'mj-event-navigatin-drop-down-menu': EventNavigationDropDownMenu,
    'mj-profile-drop-down-menu': ProfileDropDownMenu,
    'mj-notifications-drop-down-menu': NotificationsDropDownMenu,
  },

  computed: {
    ...mapGetters(['isInitalized', 'isDefaultUser', 'hasFinishedWizard', 'isSpotifyAuthorized']),

  },
};

</script>

<style lang="scss" scoped>

.header {

  @apply h-64;
  @screen sm {
    height: 21.875rem;
  }

  background: radial-gradient(
    farthest-corner at 50% 10%,
    theme('colors.purple-light') 8%,
    theme('colors.purple-dark') 100%
  );

  &-controls {
    @screen sm {
    max-height: 5rem;
    }
  }
}

</style>
